// Keep navigation within the menu that owns the event, including nested menus.
export const onMenuKeydown = event => {
  const menu = event.currentTarget;
  if (event.target.closest('[data-menu-list]') !== menu) return;
  if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
  if (
    ['Home', 'End'].includes(event.key) &&
    event.target.matches('input, textarea')
  )
    return;

  const items = Array.from(
    menu.querySelectorAll('button:not(:disabled), a[href]')
  ).filter(
    item =>
      item.closest('[data-menu-list]') === menu &&
      !item.closest('[aria-disabled="true"], [inert]') &&
      !item.closest('[data-menu-search]') &&
      item.getClientRects().length
  );
  if (!items.length) return;
  event.preventDefault();
  event.stopPropagation();
  const current = items.indexOf(event.target.closest('button, a'));
  let next;
  if (event.key === 'Home') next = 0;
  else if (event.key === 'End') next = items.length - 1;
  else if (event.key === 'ArrowUp')
    next = current <= 0 ? items.length - 1 : current - 1;
  else next = (current + 1) % items.length;
  items[next].focus();
};
